var Midnight = {
    init:function(){

        console.log('midnight')
        $('.header .wrapper').midnight();
    }
}